import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_MOSTRAR_ERRORS
} from '../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const mostrarErrors = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_MOSTRAR_ERRORS:
            return true;

        default:
            return state;
    }
};

export default mostrarErrors;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/mostrarErrors.js